import { SiteLocale } from "~~/server/graphql/datocms/generated";

const cultureToDatoEnum: Map<string, SiteLocale> = new Map([
  ["nl-be", SiteLocale.NlBe],
  ["fr-be", SiteLocale.FrBe],
]);

const cultureToIntlLocale: Map<string, string> = new Map([
  ["nl-be", "nl-BE"],
  ["fr-be", "fr-BE"],
]);

const cultureToLcid: Map<string, number> = new Map([
  ["nl-be", 2067],
  ["fr-be", 2060],
]);

const datoEnumToCulture: Map<SiteLocale, string> = new Map([
  [SiteLocale.NlBe, "nl-be"],
  [SiteLocale.FrBe, "fr-be"],
]);

const languageCodeToLocaleCode: Map<string, string> = new Map([
  ["nl", "nl-be"],
  ["fr", "fr-be"],
]);

const lcidToCulture: Map<number, string> = new Map([
  [2067, "nl-be"],
  [2060, "fr-be"],
]);

const lcidToLanguageCode: Map<number, string> = new Map([
  [2067, "nl"],
  [2060, "fr"],
]);

export function getUrlLangCodeFromDatoLocale(locale: SiteLocale): string {
  return datoEnumToCulture.get(locale) ?? "nl-be";
}

export function getUrlCodeFromLanguageCode(languageCode: string): string {
  if (languageCode.length === 2) {
    return languageCodeToLocaleCode.get(languageCode) ?? "nl-be";
  }

  return languageCode.toLocaleLowerCase();
}

export function getCultureFromLcid(lcid: number): string {
  return lcidToCulture.get(lcid) ?? "nl-be";
}

export function getLanguageCodeFromLcid(lcid: number): string {
  return lcidToLanguageCode.get(lcid) ?? "nl";
}

export function getDatoLocaleFromCulture(culture: string): SiteLocale {
  return cultureToDatoEnum.get(culture.toLocaleLowerCase()) ?? SiteLocale.NlBe;
}

export function getIntlLocaleFromCulture(culture: string): string {
  return cultureToIntlLocale.get(culture.toLocaleLowerCase()) ?? "nl-BE";
}

export function getLcidFromCulture(culture: string): number {
  return cultureToLcid.get(culture.toLocaleLowerCase()) ?? 2067;
}

export function getLocaleCodeFromLanguageCode(languageCode: string): string {
  return languageCodeToLocaleCode.get(languageCode) ?? "nl-be";
}

export function getDatoCmsLocaleList(): SiteLocale[] {
  return Array.from(datoEnumToCulture.keys());
}

export function getLcidList(): number[] {
  return Array.from(lcidToCulture.keys());
}

export function getLanguageCodeList(): string[] {
  return Array.from(languageCodeToLocaleCode.keys());
}
